export default __webpack_public_path__ + "static/0268-3a6fecf3796c583bfa6dbe81af559ea9.png";